import React from 'react'
import Header_gamebox from '../Components/Header_gamebox'

const Tnc = () => {

  return (
    <div>
      <Header_gamebox/>
      <div class="flex justify-center items-center">
        <h2 class="text-3xl font-bold mt-6 m-4">Game Box Terms and Conditions</h2>
      </div>
      <div class="lg:p-8 lg:m-8 p-4 m-4 flex justify-center items-center">
      <p>
      <strong>1. Introduction</strong>
      <br/>
      {/* 2. 1.1 Game Box is a game where subscribers answer Game Box questions correctly
 to earn points and qualify for daily and monthly draws and stand a chance to win a trip to watch the EPL finals, 
cash and airtime. The minimum point to qualify for a draw is 10 points. All users qualify for the daily draw automatically
 because all users get 10 points on subscription and renewal daily. Subscription prices are N150/day and N200/week in game. 
By 6 pm each day, entries close and a draw is held, any entry after 6 pm will be considered for the following day. */}

2. 1.1 GameBox is your ultimate destination for mobile gaming and entertainment!
 With a subscription fee of ₦150 daily or ₦200 weekly, you gain access to a wide variety of exciting games 
across multiple categories, including action, puzzles, sports, strategy, trivia, arcade, and more. Enjoy endless fun,
 discover new challenges, and play your favorite games anytime, anywhere. The daily plan gives you uninterrupted access
 for 24 hours, while the weekly plan keeps the excitement going for 7 days. GameBox delivers a fun-filled and engaging
 gaming experience for players of all ages.
      <br/>
      <br/>
      3. 3.1 Service is available to all MTN Nigeria customers with a valid mobile number (“Player/s”).Subscribing
      <br/>
      <br/>
      4.1 Players must subscribe to the Service by either SMS(by texting GB or GB7 to 13276),.
      <br/>
      <br/>
      <br/>
      <strong>Winner Determination</strong>
      <br/>
      4.2 Daily winners are selected via computer/machine draw for the grand prize and daily prizes.
      <br/>
      <br/>
      <strong>Unsubscribing:</strong>
      <br/>
      4.5 Players can unsubscribe via SMS, users simply text:
      <br/>
      - STOP GB to 13276(daily)
      <br/>
      - STOP GB7 to 13276(weekly)
      <br/>
      4.6 Players will receive an SMS confirming that they have been unsubscribed from the service. 
      <br/>
      {/* 4.7 If they unsubscribe from the service, they are not eligible for the draws and the prizes., */}
      <br/>
      <br/>
      {/* <strong>5. Prizes</strong>
      <br/>
      5.1 Winners stand a chance to win the following prizes: 
      <br/>
      <br/>
      <div class="border-2 border-black border-solid lg:w-[400px]">
      <strong class="flex justify-center items-center  " style={{borderBottom:'2px solid black'}}>
      DAILY PRIZES
      </strong>
      <br/>
      <p class=" m-0 " style={{borderBottom:'2px solid black'}}> 
      A trip to watch EPL or Cash Equivalent
      </p>
      <br/>
      <p class=" m-0" style={{borderBottom:'2px solid black'}}>Cash Prizes (N1000,000)</p>
      <p className='p-2 m-0'>Airtime</p>
      </div>
      <br/>
      <strong>6. General</strong>
      6.1 Winners of cash prizes will be notified the following day via SMS to send in their bank details with the corresponding mobile number they played with to claim their prize.
      <br/>
6.2 Cash prize winners will be credited via MTN MoMo. .
<br/>
6.3 The grand prize winner(s) bound for a trip to watch the EPL finals live, must have a valid international passport valid for a minimum of six(6) months, if otherwise, the winner(s) is/are disqualified from the trip, and another winner(s) will be selected.
<br/>
6.4 Airtime winners get credited automatically.
<br/>
6.5 All subscribers on subscription get 10 points, same with the subscribers on renewals. For weekly subscribers, such subscribers get 10 points daily, and qualify for the daily draw.
<br/>
6.6 The Service begins immediately after the user subscribes.
<br/>
6.7EMT reserves the right, at any time, to change these Terms and Conditions and any rules relating to its products and the Service, and to modify the Services at its discretion.
<br/>
6.8 EMT reserves the right from time to time to vary the charges of the Service as may be deemed necessary in its discretion.
<br/>
6.9 EMT shall be entitled to terminate the Service of any Customer, if such Customer is involved in any fraudulent activity or suspected fraudulent activity.
<br/> */}
      </p>

      </div>
    </div>
  )
}

export default Tnc
